import React from 'react';
import GovtStrip from './Govtstrip';
import Navbar from './Navbar';
import Strip from './Strip';

function Header() {
  return (
    <div>
      <Strip />
      <GovtStrip />
      <Navbar />
    </div>
  );
}

export default Header;
